/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import config from "../../../config";
import axiosClient from "../../../_helpers/http.helper";
import SalesRepDigitalCollections from "./SalesRepDigitalCollections";
import SalesRepPrintCollections from "./SalesRepPrintCollections";
import { Tabs, Pane } from "@pearson-components/elements-sdk/build/dist.elements-sdk";
import union from "lodash/union";
import {formatUrl} from "../../../_helpers/urlFormat.helper";
import { asyncWrapper } from "../../../_helpers/async.helper";
import { AuthConsumer } from "../../context/AuthContext";

class SalesRepCollectionList extends React.Component {
    static contextType = AuthConsumer;
    constructor(props) {
        super(props);
        this.state = {
            printCollection: {
                totalItems: 0,
                pageNumber: null,
                items: []
            },
            digitalCollection: {
                totalItems: 0,
                pageNumber: null,
                items: []
            },
            hasMorePrintCollections: true,
            hasMoreDigitalCollections: true,
            selectedTabIndex: 0,
            selected: [],
            collectionIds: [],
            loading: false,
            showSearchError: false,
        };
    }
    
    async componentDidMount() {
        const {error: printError, data: printCollections} = await asyncWrapper(this.getCollectionsList('print'));
        const {error: digitalError, data: digitalCollections} = await asyncWrapper(this.getCollectionsList('digital'));
        if (printError || digitalError) {
            if (digitalError.response.data.errorCode == "CL009") {
                this.setState({
                    showSearchError: true
                });
            }
        }
        else {
            this.setState({
                loading: false,
                printCollection: {
                    items: printCollections.data.content,
                    pageNumber: printCollections.data.number,
                    totalItems: printCollections.data.totalElements,
                },
                digitalCollection: {
                    items: digitalCollections.data.content,
                    pageNumber: digitalCollections.data.number,
                    totalItems: digitalCollections.data.totalElements,
                },
                showSearchError: false,
                hasMorePrintCollections: !printCollections.data.last,
                hasMoreDigitalCollections: !digitalCollections.data.last,
            });
        }
                
    }

    getCollectionsList(type, pageNumber = 0) {
        let url = formatUrl(config.collectionService.baseUrl, config.collectionService.routes.getCollectionList, {
            type,
            queryParams: {
                pageNumber,
                pageSize: 10,
                userId: this.props.userProfile.id
            }
        });
        return axiosClient.get(url);
    }
    loadMoreSalesRepPrintCollections = async () => {
        if (!this.state.hasMorePrintCollections) {
            return;
        }
        let pageNumber = this.state.printCollection.pageNumber === null ? 0 : this.state.printCollection.pageNumber + 1;
        const {error: printError, data: printCollections} = await asyncWrapper(this.getCollectionsList('print', pageNumber));
        if (printCollections) {
            this.setState(prevState => ({
                printCollection: {
                    items: union([
                        ...prevState.printCollection.items,
                        ...printCollections.data.content
                    ], 'transactionId'),
                    pageNumber: printCollections.data.number,
                    totalItems: printCollections.data.totalElements,
                    loading: false
                },
                selectedTabIndex: 0,
                hasMorePrintCollections: !printCollections.data.last,
            }));
        }
    };

    loadMoreSalesRepDigitalCollections = async () => {
        if (!this.state.hasMoreDigitalCollections) {
            return;
        }
        let pageNumber = this.state.digitalCollection.pageNumber === null ? 0 : this.state.digitalCollection.pageNumber + 1;
        const {error: digitalError, data: digitalCollections} = await asyncWrapper(this.getCollectionsList('digital', pageNumber));
        if (digitalCollections) {
            let collectionIds = digitalCollections.data && digitalCollections.data.content.map(item => {
                return item.collection.collectionId;
            });
            this.setState(prevState => {
                return ({
                    digitalCollection: {
                        items: union([
                            ...prevState.digitalCollection.items,
                            ...digitalCollections.data.content
                        ], 'transactionId'),
                        pageNumber: digitalCollections.data.number,
                        totalItems: digitalCollections.data.totalElements,
                        loading: false
                    },
                    selectedTabIndex: 1,
                    hasMoreDigitalCollections: !digitalCollections.data.last
                });
            });
        }
    };
 
    render() {  
        return (
            <div>
                <div className="collectionList-container">
                    <div className="content-home-page">
                        <div>
                            <label className="pe-page-title--small">Sales Rep Capabilities</label>
                            <hr/>
                        </div>
                        <label className="pe-page-title--small"> <h6>Year to date - List of collections created by you</h6> </label>
                        
                        <h6 className="collection-count">
                            {this.state.printCollection.totalItems ? this.state.printCollection.totalItems + " Print results " : "0 Print results"}
                            {this.state.digitalCollection.totalItems ? "|" + this.state.digitalCollection.totalItems + " Digital results " : " | 0 Digital results"}
                        </h6>
                    </div>
                </div>
                <Tabs selected={this.state.selectedTabIndex}>
                    <Pane label={"Print Collections"}>
                        {this.state.printCollection.totalItems > 0  ?<SalesRepPrintCollections
                            selectedData={this.state.selected}
                            collections={this.state.printCollection}
                            hasMore={this.state.hasMorePrintCollections}
                            loadMore={this.state.isPending?this.loadMoreSalesRepPrintCollections:this.loadMorePrintCollections}/> : <div className="no-collection-lable">No Print Collections</div>}
                    </Pane>
                    <Pane label={"Digital Collections"}>
                        {this.state.digitalCollection.totalItems > 0  ? <SalesRepDigitalCollections
                            selectedData={this.state.selected}
                            collections={this.state.digitalCollection}
                            hasMore={this.state.hasMoreDigitalCollections}
                            loadMore={this.state.isPending?this.loadMoreSalesRepDigitalCollections:this.loadMoreDigitalCollections}
                        /> : <div className="no-collection-lable">No Digital Collections</div>}
                    </Pane>
                </Tabs>
            </div>
            
        );          
    }
}
const collectionList = (props) => (
    <AuthConsumer>
        {({userProfile}) => <SalesRepCollectionList {...props} userProfile={userProfile} />}
    </AuthConsumer>
);

export default collectionList;


// WEBPACK FOOTER //
// ./src/components/pages/SaleRepCapabilities/collectionList.js